import React, { Component } from 'react';
import { View, Text } from 'react-native';
import { SImage, STheme, SView } from 'servisofts-component2';

import Type1 from "./type1"
// import Type2 from "./type2"
// import Type3 from "./type3"
// import Type4 from "./type4"


export default class AccentBar extends Component<{ type: "1" | "2" | "3" | "4" }> {

    static Acent3 = <AccentBar type='4' top={60} />
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        let SELECT = Type1;
        if (this.props.type == "1") SELECT = Type1;
        // if (this.props.type == "2") SELECT = Type2;
        // if (this.props.type == "3") SELECT = Type3;
        // if (this.props.type == "4") SELECT = Type4;
        return <SELECT {...this.props} />
    }
}
